import { ResolvedViewerUsers } from "./TaskViewerUsers";
import { ViewerAvatars } from "./ViewerAvatars";

/** The avatars of a task's viewers, resolved against the organization's staff on organization-wide pages. */
export const TaskViewerAvatars = ({ userIds }: { userIds: number[] }) => (
    <ResolvedViewerUsers userIds={userIds}>
        {(users) => <ViewerAvatars users={users} />}
    </ResolvedViewerUsers>
);
